import { logWrapper } from '../../utils';

export default {
  documentsController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'revisionService',
    '$filter',
    '$state',
    '$controller',
    'searchService',
    'authService',
    'folderService',
    'EDocumentStatus',
    '$uibModal',
    'documentsPagingService',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      revisionService,
      $filter,
      $state,
      $controller,
      searchService,
      authService,
      folderService,
      EDocumentStatus,
      uibModal,
      documentsPagingService
    ) {
      'use strict';

      function loadDocs() {
        $scope.loadDocuments();
      }

      function itemsFilter(item) {
        return item.idStatus !== EDocumentStatus.TRASH_CAN && !item.removed;
      }

      function canMove() {
        var docs = $scope.selectedDocuments();
        if (docs.length === 0) return false;
        return docs.every((d) => d.idStatus === 1 || d.idStatus === 4);
      }

      function loadDocuments() {
        if ($scope.currentPage < 1) {
          $scope.goToPage(1);
        } else {
          if ($scope.idfolder) {
            $scope.searching = false;

            $scope.description = 'LOADING DOCUMENTS';
            $scope.documents(null);

            $scope.loading = true;

            revisionService.cancelLoadRevisions();
            searchService.cancel();
            $scope.searchTerm = '';

            $rootScope.currentDocument = null;
            $scope.count = 0;

            $rootScope.$broadcast('loadFolder', $scope.idfolder);

            folderService.cancelLoad();
            folderService
              .load($scope.idfolder)
              .then((data) => {
                $scope.treeItem = data;

                $scope.title = $scope.treeItem.Name;
                $scope.load(true);
              })
              .catch(() => {
                $scope.loading = false;
                return;
              });
          } else {
            if (
              $rootScope.user &&
              $rootScope.user.userPreferences &&
              authService.authentication.email !== 'autologin'
            ) {
              $rootScope.$broadcast(
                'loadFolder',
                $rootScope.user.userPreferences.IdLastFolder
              );
              $scope.goTo($scope.user.userPreferences.IdLastFolder);
            } else {
              $scope.loading = false;
            }
          }
        }
      }

      function goTo(id) {
        var p = $state.params.page ? $state.params.page : 1;
        switch (id) {
          case -2:
            $state.go('home.shareds', {
              page: p,
            });
            break;
          case -3:
            $state.go('home.digitalizations', {
              page: p,
            });
            break;
          case -4:
            $state.go('home.checkouts', {
              page: p,
            });
            break;
          case -5:
            $state.go('home.favorites', {
              page: p,
            });
            break;
          case -6:
            $state.go('home.trashcan', {
              page: p,
            });
            break;
          case -7:
            $state.go('home.publicLinks', {
              page: p,
            });
            break;
          case -8:
            $state.go('home.myDeadLines', {
              page: p,
            });
            break;
          default:
            $state.go('home.folder', {
              id: id,
              page: p,
            });
            break;
        }
      }

      function goToPage(page) {
        $state.go('home.folder', {
          id: $scope.idfolder,
          page: page,
        });
      }

      function renameDocumentOnClickF2(keyEvent, document) {
        var f2buttonClicked = keyEvent.which === 113;
        var documentHasSelected = document.selected;
        if (documentHasSelected && $scope.selectedDocuments().length === 1) {
          if (f2buttonClicked) document.properties();
        }
      }

      function load(reset = false) {
        var folderColumn = [];

        if ($scope.columns.length === 0) {
          folderColumn.disabled = true;
        } else {
          folderColumn = $scope.columns.filter((c) => c.id === 'folder')[0];

          if (folderColumn !== undefined && folderColumn !== null)
            folderColumn.disabled = true;
        }

        if (reset) {
          documentsPagingService.reset();
          $scope.itens = [];
          $scope.loading = true;
        }

        $scope.page = 1;

        documentsPagingService
          .load($scope.idfolder)
          .then(res => {
            $scope.totalItem = res.total;
            $scope.itens = res.items;
            $scope.totalDisplayed = $scope.itens.length;
            $scope.loading = false;
            $scope.botaoAtivo = $scope.itens.length < $scope.totalItem;

            $scope.count = res.items.length;

            $scope.documents(res.items);

            $scope.groups = [];

            if ($scope.totalItem > $scope.limite) {
              $scope.limiteValor = $scope.limite;
              $scope.botaoAtivo = true;
            } else {
              $scope.limiteValor = $scope.totalItem;
              $scope.botaoAtivo = false;
            }

            $scope.description = $scope.getDescription(
                $scope.currentPage,
                $scope.pageSize,
                res.total,
                $scope.totalDisplayed);
          })
          .catch((data) => {
            if (
              data.status_code === 500 &&
              $scope.selectedTreeItem.Name === 'CHECKOUTS'
            ) {
              $scope.documents([]);
              return;
            }
          });

          authService.getUserAsync().then(user => {
            user.userPreferences.IdLastFolder = $scope.idfolder;
          });

        $scope.configColumns();
      }

      function questionModal() {
        $scope.loading = true;
        var revision = $scope.$resolve?.revisions;

        revisionService.
          convertToPdf(revision.id)
          .then(() => {
            $scope.modalQuestion.close();
            $scope.loading = false;

            $scope.messageTitle = $filter('translate')('CONVERTED DOCUMENT');
            $scope.messageDescription = $filter('translate')('A NEW REVISION HAS BEEN GENERATED');

            $rootScope.convertToPdfSucessModal = uibModal.open({
              animation: true,
              backdrop: 'static',
              templateUrl: '/views/modal/successModal/successModal.html',
              controller: function ($scope, $uibModalInstance, messageTitle, messageDescription) {
                $scope.messageTitle = messageTitle;
                $scope.messageDescription = messageDescription;

                $scope.closeSuccessModal = function () {
                  $rootScope.loadDocs();
                  $uibModalInstance.close();
                };
              },
              resolve: {
                messageTitle: () => $scope.messageTitle,
                messageDescription: () => $scope.messageDescription
              },
              size: 'small'
            });
          })
          .catch(() => {
            $scope.modalQuestion.close();
          });
      }

      function run() {
        try {
          $controller('baseController', { $scope: $scope });
          $controller('chatbotController', { $scope: $scope });

          $rootScope.$broadcast('clearSearchTerm');
          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.imageTypes = ['png', 'gif', 'jpeg', 'jpg', 'bmp'];
          $scope.title = '';
          $scope.description = '';
          $scope.searchTerm = '';

          if ($state.params.id) $scope.idfolder = parseInt($state.params.id);

          if (!$state.params.page && $scope.idfolder !== undefined) {
            $state.go('home.folder', {
              id: $scope.idfolder,
              page: 1,
            });
          }

          $scope.noDocuments = $scope.idfolder
            ? $filter('translate')('NO DOCUMENTS')
            : $filter('translate')('NO FOLDER SELECTED');

          $scope.noDocumentsMessage = $scope.idfolder
            ? $filter('translate')('NO DOCUMENTS MSG')
            : $filter('translate')('NO FOLDER SELECTED MSG');

          $scope.itemType = 0;
          $scope.groups = null;
          $scope.currentGroup = null;
          $scope.canView = false;
          $scope.searching = false;
          $scope.loading = true;
          $scope.selectedTreeItem = null;
          $scope.count = 0;
          $rootScope.loadDocs;
          $rootScope.isF2Clicked = false;

          $rootScope.loadDocs = logWrapper(
            loadDocs,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.itemsFilter = logWrapper(
            itemsFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canMove = logWrapper(
            canMove,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocuments = logWrapper(
            loadDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goTo = logWrapper(
            goTo,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goToPage = logWrapper(
            goToPage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.renameDocumentOnClickF2 = logWrapper(
            renameDocumentOnClickF2,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.load = logWrapper(
            load,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.questionModal = logWrapper(
            questionModal,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
